<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Prequalification Details</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    class="dialog-close-button"
    mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <h6>Pre-Qualification Name</h6>
  <p id="name">{{ prequal.name }}</p>

  <ng-container *ngIf="prequal.description != ''">
    <h6>Pre-Qualification Description</h6>
    <p>{{ prequal.description }}</p>
  </ng-container>

  <h6>Client</h6>
  <p>{{ prequal.account?.name }}</p>

  <h6>Health and Safety Score</h6>
  <p>{{ prequal.score }}%</p>

  <app-my-items
    *ngIf="prequal?.items.length > 0"
    [items]="prequal.items"
    [edit]="false"
    [hash]="prequal.hash"
  ></app-my-items>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-3 py-2">
  <button
    class="my-2 ml-1 mr-2"
    mat-raised-button
    (click)="downloadPdf()"
    color="secondary">
    <mat-icon>save_alt</mat-icon>
    Download as PDF
  </button>

  <div class="ml-lg-auto">
    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="primary"
      aria-label="Share"
      matTooltip="Open this shareable link in a new tab"
      (click)="onOpenUrl(shareLink)">
      <mat-icon>open_in_new</mat-icon>
      Share
    </button>

    <button
      mat-button
      type="button"
      ngxClipboard
      [cbContent]="shareLink"
      (click)="notifyCopied()"
      class="my-2 ml-1 mr-2"
      matTooltip="Copy the share link to clipboard">
      <mat-icon>file_copy</mat-icon>
      Copy Link
    </button>
  </div>
</mat-dialog-actions>
